import { useEffect, useState } from "react";
import Dropdown from "../../../../common/components/inputFields/dropdown/dropdown";
import TextField from "../../../../common/components/inputFields/textFields/textField";
import {
  QuestionTypes,
  QuestionTypesHelper,
} from "../../../../common/enums/questionTypes";
import { Color } from "../../../../common/style/colors";
import { QuestionModel } from "../../models/questionModel";
import MultipleChoice from "../answerOptions/multipleChoice/multipleChoice";
import MultipleChoose from "../answerOptions/multipleChoose/multipleChoose";
import { ReactComponent as Exit } from "../../../../assets/exitIcon.svg";
import { ReactComponent as Arrow } from "../../../../assets/arrowIcon.svg";
import "./questionArea.scss";

export default function QuestionArea(props: {
  questionData?: QuestionModel;
  onChange?: (e: QuestionModel) => void;
  onClickClose?: () => void;
  onClickUp?: () => void;
  onClickDown?: () => void;
}) {
  const [question, setQuestion] = useState<QuestionModel>(
    props.questionData ??
      ({
        questionType: QuestionTypes.MULTIPLE_CHOICE,
      } as QuestionModel)
  );

  useEffect(() => {
    props.onChange?.(question);
  }, [question]);

  return (
    <div style={{ display: "flex", gap: "0.5rem" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        <Arrow
          height={12}
          width={12}
          stroke={Color().blackColor}
          className={"arrowUp"}
          style={{ cursor: "pointer" }}
          onClick={props.onClickUp}
        />
        <Arrow
          height={12}
          width={12}
          stroke={Color().blackColor}
          className={"arrowDown"}
          style={{ cursor: "pointer" }}
          onClick={props.onClickDown}
        />
      </div>
      <div className="question-area">
        <div className="question-area-header">
          <TextField
            initialValue={question.questionTitle ?? "Untitled Question"}
            fontSize="16px"
            padding="2px"
            hideBorder
            onChange={(e) => {
              let newData = {
                ...question,
                questionTitle: e,
              } as QuestionModel;
              setQuestion(newData);
            }}
            maxWidth={"150px"}
          />
          <Dropdown
            initialValue={{
              value: question.questionType ?? "Multiple Choice",
              label: question.questionType ?? "Multiple Choice",
            }}
            options={Object.values(QuestionTypes).map((e) => ({
              value: e,
              label: e,
            }))}
            onChange={(e) => {
              let newData = {
                ...question,
                questionType: QuestionTypesHelper.fromValue(e.value),
              } as QuestionModel;
              setQuestion(newData);
            }}
            isFullWidth={false}
            padding={"0.25rem"}
            backgroundColor={Color().tertiaryColor}
            border={`2px solid ${Color().tertiaryColor}`}
          />
          <div style={{ flex: 1 }} />
          <Exit
            height={20}
            width={20}
            onClick={props.onClickClose}
            style={{ cursor: "pointer" }}
            stroke={"black"}
          />
        </div>
        <hr />
        {question?.questionType !== QuestionTypes.SHORT_ANSWER && (
          <div className="choices-container">
            {question?.questionType === QuestionTypes.MULTIPLE_CHOICE && (
              <MultipleChoice
                optionsData={question.options}
                onChange={(e) => {
                  let newData = {
                    ...question,
                    options: e,
                  } as QuestionModel;
                  setQuestion(newData);
                }}
              />
            )}
            {question?.questionType === QuestionTypes.MULTIPLE_CHOOSE && (
              <MultipleChoose
                optionsData={question.options}
                onChange={(e) => {
                  let newData = {
                    ...question,
                    options: e,
                  } as QuestionModel;
                  setQuestion(newData);
                }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
